<template>
  <v-card>
      <v-card-text class="text-xs-center headline primary--text">
          Detalhes da Fatura
      </v-card-text>
      <v-card-text>
        <v-layout justify-end>
          <v-btn @click="irParaRelatorio" small round color="primary"><v-icon>visibility</v-icon> Visualizar Relatório</v-btn>
        </v-layout>
        <v-list class="pt-0">
            <template v-for="(item, index) in fatura.tipos_faturamento">
                <v-list-tile :key="index" avatar>
                    <v-list-tile-avatar>
                      <v-icon color="green">attach_money</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                        <v-list-tile-title v-text="`Valor: R$ ${item.valor}`" class="font-weight-light">
                        </v-list-tile-title>
                        <v-list-tile-sub-title v-text="item.descricao"></v-list-tile-sub-title>
                    </v-list-tile-content>
                </v-list-tile>
                <v-divider :key="`divider-${index}`"></v-divider>
            </template>
        </v-list>
        <h4 class="mt-4" v-if="valor_total">Valor total da fatura: {{valor_total.toFixed(2).replaceAll(',', '').replace('.', ',')}}</h4>
        <h4>Desconto aplicado de: {{desconto}}%</h4>
        <h3 class="text-xs-right mt-2" v-if="fatura && fatura.valor_faturamento">Valor a receber: {{fatura.valor_faturamento.replaceAll(',', '').replace('.', ',')}}</h3>
      </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: ['id_fatura', 'desconto'],
  data () {
    return {
      fatura: {},
      dialogCobranca: false,
      dialogEditCobranca: false,
      cobrancaSelecionada: null,
      recargas: []
    }
  },
  computed: {
    valor_total () {
      if (!this.fatura || !this.fatura.proposta) return 0
      return this.fatura.valor_faturamento / (1 - this.fatura.proposta.desconto / 100)
    }
  },
  beforeMount () {
    if (this.id_fatura) {
      this.carregarDetalhes()
    }
  },
  watch: {
    id_fatura (val) {
      if (val) {
        this.carregarDetalhes()
      }
    }
  },
  methods: {
    abrirEdicao (cobranca) {
      this.cobrancaSelecionada = cobranca
      this.dialogEditCobranca = true
    },
    carregarDetalhes () {
      this.$store.dispatch('detalhesFaturamento', this.id_fatura).then(json => {
        this.fatura = json
      })
    },
    irParaRelatorio () {
      this.$router.push('/relatorio/vouchers')
    }
  }
}
</script>
